'use strict';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import BuyAccessCode from 'components/signUp/BuyAccessCode';

function mapStateToProps(state) {
  return {
    accessUrl: state.signupReducer.get('accessUrl')
  };
}
function mapDispatchToProps(dispatch) {
  return {
    actions: {
      signUpActions: bindActionCreators(require('actions/signUpActions'), dispatch)
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(BuyAccessCode);



// WEBPACK FOOTER //
// ./src/containers/BuyAccessCodeContainer.js